import React from 'react'
import '../styles/Experience.css'
const Experience = () => {
  return (
    <div className="experience">
        <h3 style={{fontWeight:'bold'}}>
        SUGS Josip Broz Tito
        </h3>
        <p> High School Diploma 2011-2015 </p>
      
        <h3 style={{fontWeight:'bold'}}>
          FINKI 
        </h3>

        <h4 >
          Bachelor's Degree 2015-2023
        </h4>

        <p> Computer Science</p>
     
      
 
        <h3 style={{fontWeight:'bold'}}>
          SMX Academy
        </h3>
        
        <p>
         Dec 2021 - Sep 2022
        </p>
 
  </div>
);
}
export default Experience